<template>
  <circle
    class="donut-svg-background"
    :cx="centerX"
    :cy="centerY"
    :r="radius"
    :stroke-width="strokeWidth"
  />
</template>

<script>
/**
 * A background circle for use in donut charts.
 *
 * Note: This should always be used inside of an `<svg>` element.
 */
export default {
  name: 'DonutSvgBackground',
  props: {
    centerX: {
      type: Number,
      required: true,
    },
    centerY: {
      type: Number,
      required: true,
    },
    radius: {
      type: Number,
      required: true,
    },
    strokeWidth: {
      type: Number,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.donut-svg-background {
  fill: transparent;
  stroke: rgba($grayLighter, 0.5);
}
</style>
